import React from 'react';

import { ButtonInnerWithLoadingState } from '../ButtonInner/ButtonInnerWithLoadingState';
import { getCustomBackgroundStyle, getHoverStyle } from './getCustomStyles';
import type { SolidButtonLinkProps } from './types';
import { buttonSize } from '../styles/buttonSizes.styles';
import * as styles from './SolidButton.styles';

export const SolidButtonLink = ({
  active,
  children,
  compact = false,
  customBackgroundColor,
  fullWidth = false,
  loading = false,
  textColorMode = 'light',
  ...props
}: SolidButtonLinkProps) => (
  <a
    data-is-active={active}
    {...props}
    css={[
      styles.solidButtonLink,
      getHoverStyle(textColorMode, customBackgroundColor),
      getCustomBackgroundStyle(customBackgroundColor),
      buttonSize(compact, fullWidth),
    ]}
  >
    <ButtonInnerWithLoadingState compact={compact} loading={loading} textColorMode={textColorMode}>
      {children}
    </ButtonInnerWithLoadingState>
  </a>
);
